module.exports = __webpack_public_path__ + "static/media/QRcode2.aa8c546e.png";